import React, { useRef, useEffect } from 'react';
import {
  TranscriptText,
  TranscriptSegment,
  TranscriptContainer,
} from './styles';

type Segment = {
  text: string;
};

type TranscriptProps = {
  segments: Segment[];
};

export const Transcript = ({ segments }: TranscriptProps) => {
  const prevLenRef = useRef(0);
  const prevLen = prevLenRef.current;

  useEffect(() => {
    prevLenRef.current = segments.length;
  }, [segments.length]);

  return (
    <TranscriptContainer>
      <TranscriptText>
        {segments.map((seg, i) => {
          const isNew = i >= prevLen;
          const newIndexOffset = i - prevLen;
          const delay = isNew ? Math.min(newIndexOffset * 80, 800) : 0;

          return (
            <TranscriptSegment key={i} $animate={isNew} $delay={delay}>
              {seg.text}
            </TranscriptSegment>
          );
        })}
      </TranscriptText>
    </TranscriptContainer>
  );
};
